import {client} from '../helpers/api';

export async function getStates() {
  const response = await client.get('/v1/states');

  if (response.data?.status) {
    return (
      response.data?.data.map(({state_id: id, state_name: name}) => ({
        id,
        name,
      })) || []
    );
  }
  throw response;
}

// {
//   state_id: "5717ab49-7b08-4efe-a1a9-43db4cd30159",
//   state_name: "Johor"
// }
